import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './components/Home';
import CalculatorDashboard from './components/CalculatorDashboard';
import FruitPlanner from './components/FruitPlanner';
import ComparisonTools from './components/ComparisonTools';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    // Check local storage for user preference or system preference
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });
  
  useEffect(() => {
    // Update document class and store preference
    if (darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);
  
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };
  
  return (
    <Router>
      <div className={`min-h-screen transition-theme duration-300 ease-in-out ${
        darkMode 
          ? 'bg-background-dark text-gray-100' 
          : 'bg-background-light text-gray-900'
      }`}>
        <Navigation darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
        <div className="container mx-auto px-4 py-8 max-w-7xl">
          <Routes>
            <Route path="/" element={<Home darkMode={darkMode} />} />
            <Route path="/calculator" element={<CalculatorDashboard darkMode={darkMode} />} />
            <Route path="/fruit-planner" element={<FruitPlanner darkMode={darkMode} />} />
            <Route path="/comparison" element={<ComparisonTools darkMode={darkMode} />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
